<template>
  <section class="mt-8" data-testid="story-slider-section">
    <div class="w-screen overflow-hidden">
      <div class="">
        <div class="h-[404px] md:mx-auto md:max-w-[1168px] md:justify-center">
          <div class="mx-4">
            <HorizontalScrollWrapper scroll-button-box-style="md:h-full" :gap="4" :scroll-box-style="props.stories.length <= 3 ? 'md:justify-center' : 'md:justify-start'">
              <template v-for="(story, index) in props.stories" :key="index + story.id">
                <StoryTallCard :data-testid="`story-vertical-card-${index}`" :story="story" />
              </template>
            </HorizontalScrollWrapper>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { HorizontalScrollWrapper } from '@/wabunka-src/common/components';
import { type StoryListViewModel, StoryTallCard } from '@/wabunka-src/features/Story';

interface Props {
  stories: StoryListViewModel;
}

const props = defineProps<Props>();
</script>
